// extracted by mini-css-extract-plugin
export default {"outlet":"users_outlet__v75yg","title":"users_title__4ygMu","users":"users_users__SHKmd","deleteMany":"users_deleteMany__s4wqe"};